import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ClientBalanceBaseEffect } from './client-balance-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ ClientBalanceBaseEffect ])
  ]
})
export class ClientBalanceBaseModule {

}
